export default {
  slug: "remote-development",
  code: "REM",
  label: "Remote Development",
  logoFamily: "jb",
};
